export const API_READ_REWARDS = 'GET_REWARDS' as const;
export const API_READ_REWARDS_SUCCESS = 'GET_REWARDS_SUCCESS' as const;
export const API_READ_REWARDS_FAILURE = 'GET_REWARDS_FAILURE' as const;

export const API_SAVE_REWARDS_OPT_IN = 'REWARDS_OPT_IN' as const;
export const API_SAVE_REWARDS_OPT_IN_REQUEST =
  'REWARDS_OPT_IN_REQUEST' as const;
export const API_SAVE_REWARDS_OPT_IN_SUCCESS =
  'REWARDS_OPT_IN_SUCCESS' as const;
export const API_SAVE_REWARDS_OPT_IN_FAILURE =
  'REWARDS_OPT_IN_FAILURE' as const;

export const API_SAVE_REWARDS_OPT_OUT = 'REWARDS_OPT_OUT' as const;
export const API_SAVE_REWARDS_OPT_OUT_REQUEST =
  'REWARDS_OPT_OUT_REQUEST' as const;
export const API_SAVE_REWARDS_OPT_OUT_SUCCESS =
  'REWARDS_OPT_OUT_SUCCESS' as const;
export const API_SAVE_REWARDS_OPT_OUT_FAILURE =
  'REWARDS_OPT_OUT_FAILURE' as const;
